'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _LinkButton = require('../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _UserAvatar = require('../../../../components/userAvatar/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _UserName = require('../../../../components/userAvatar/UserName');

var _UserName2 = _interopRequireDefault(_UserName);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _teamManagementActions = require('../teamManagementActions');

var _teamManagementConstants = require('../teamManagementConstants');

require('./TeamMemberEntry.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchRemoveMember: function dispatchRemoveMember(userId) {
            return dispatch((0, _teamManagementActions.removeTeamMember)({ userId: userId }));
        },
        dispatchAddMember: function dispatchAddMember(userId) {
            return dispatch((0, _teamManagementActions.addTeamMember)({ userId: userId }));
        }
    };
};

var UserStatusDescription = function UserStatusDescription(_ref) {
    var user = _ref.user,
        currentUser = _ref.currentUser;

    if (user.get('_id') === currentUser.get('_id')) return _react2.default.createElement(
        'span',
        null,
        'Admin'
    );

    return null;
};

var UserStatusAction = function UserStatusAction(_ref2) {
    var user = _ref2.user,
        currentUser = _ref2.currentUser,
        removeMember = _ref2.removeMember,
        undoRemoveMember = _ref2.undoRemoveMember;

    if (user.get('_id') === currentUser.get('_id')) return null;

    switch (user.get('memberState')) {
        case _teamManagementConstants.TEAM_MEMBER_STATES.NEW:
            return _react2.default.createElement(
                _LinkButton2.default,
                { className: 'secondary', onClickFn: removeMember },
                _react2.default.createElement(_Icon2.default, { name: 'close-x' })
            );
        case _teamManagementConstants.TEAM_MEMBER_STATES.ADDED:
            return _react2.default.createElement(
                _LinkButton2.default,
                { onClickFn: removeMember },
                'Remove from team'
            );
        case _teamManagementConstants.TEAM_MEMBER_STATES.REMOVED:
            return _react2.default.createElement(
                _LinkButton2.default,
                { onClickFn: undoRemoveMember },
                'Undo'
            );
        default:
            return null;
    }
};

var UserStatus = function UserStatus(props) {
    return _react2.default.createElement(
        'span',
        { className: 'status' },
        _react2.default.createElement(UserStatusDescription, props),
        ' ',
        _react2.default.createElement(UserStatusAction, props)
    );
};

UserStatusAction.propTypes = UserStatusDescription.propTypes = {
    user: _propTypes2.default.object,
    currentUser: _propTypes2.default.object,
    removeMember: _propTypes2.default.func,
    undoRemoveMember: _propTypes2.default.func
};

var TeamMembersEntry = function (_React$Component) {
    _inherits(TeamMembersEntry, _React$Component);

    function TeamMembersEntry() {
        _classCallCheck(this, TeamMembersEntry);

        return _possibleConstructorReturn(this, (TeamMembersEntry.__proto__ || Object.getPrototypeOf(TeamMembersEntry)).apply(this, arguments));
    }

    _createClass(TeamMembersEntry, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.memberEntry.scrollIntoView();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var index = this.props.index;


            var classes = (0, _classnames2.default)('TeamMemberEntry', {
                removed: this.props.user.get('memberState') === _teamManagementConstants.TEAM_MEMBER_STATES.REMOVED
            });

            return _react2.default.createElement(
                'div',
                { className: classes, ref: function ref(c) {
                        _this2.memberEntry = c;
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'details' },
                    _react2.default.createElement(
                        'span',
                        { className: 'index' },
                        index + 1,
                        '.'
                    ),
                    _react2.default.createElement(_UserAvatar2.default, this.props),
                    _react2.default.createElement(_UserName2.default, this.props),
                    _react2.default.createElement(UserStatus, this.props)
                )
            );
        }
    }]);

    return TeamMembersEntry;
}(_react2.default.Component);

TeamMembersEntry.propTypes = {
    user: _propTypes2.default.object,
    index: _propTypes2.default.number
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(null, mapDispatchToProps), (0, _recompose.withHandlers)({
    removeMember: function removeMember(_ref3) {
        var dispatchRemoveMember = _ref3.dispatchRemoveMember,
            user = _ref3.user;
        return function (event) {
            return dispatchRemoveMember(user.get('_id'));
        };
    },
    undoRemoveMember: function undoRemoveMember(_ref4) {
        var dispatchAddMember = _ref4.dispatchAddMember,
            user = _ref4.user;
        return function (event) {
            return dispatchAddMember(user.get('_id'));
        };
    }
}));

exports.default = enhance(TeamMembersEntry);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/membersList/TeamMemberEntry.js
// module id = 2096
// module chunks = 0